import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import SidebarSkeleton from './SidebarSkeleton';
import GlobalHeader from './GlobalHeader';
import { vehicleGroupService } from '../Services/vehicle.group.service';
import { menusService } from '../Services/menus.service';
import { useState, useEffect } from 'react';

// Rotas onde o conteúdo preenche o viewport inteiro (grade/mapa)
// Nessas telas o scroll é gerenciado internamente — o movyx-content fica com overflow: hidden
const NO_SCROLL_ROUTES = [
  '/fleet',
];

export default function NewLayout() {
  const location = useLocation();
  const [optionVehicles, setOptionVehicles] = useState([]);
  const [menuLoaded, setMenuLoaded] = useState(false);

  const isHomePage = location.pathname === '/home' || location.pathname === '/';

  const allowScroll = !NO_SCROLL_ROUTES.some(r => location.pathname.startsWith(r));

  useEffect(() => {
    const loadMenu = async () => {
      try {
        await menusService.menus();
        setMenuLoaded(true);
      } catch (err) {
        console.error("Erro ao carregar menu:", err);
        setMenuLoaded(true);
      }
    };
    loadMenu();
  }, []);

  useEffect(() => {
    if (isHomePage && menuLoaded) {
      const fetchVehicleGroups = async () => {
        try {
          const responseGroups = await vehicleGroupService.fetchGroups();
          if (responseGroups) {
            const mappedGroups = responseGroups.map(group => ({
              groupVehicleId: group.vehicleGroupId,
              groupVehicleName: group.vehicleGroupName
            }));
            setOptionVehicles(mappedGroups);
          }
        } catch (err) {
          console.error("Erro ao buscar grupos de veículos:", err);
        }
      };
      fetchVehicleGroups();
    }
  }, [isHomePage, menuLoaded]);

  if (!menuLoaded) {
    return (
      <div className="movyx-layout">
        <SidebarSkeleton />
        <div className="movyx-main">
          <div className="movyx-navbar">
            <GlobalHeader showFilters={false} optionVehicles={[]} />
          </div>
          <div className="movyx-content"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="movyx-layout">
      {/* Sidebar */}
      <Sidebar />

      {/* Main Content */}
      <div className="movyx-main">
        {/* Global Header */}
        <div className="movyx-navbar">
          <GlobalHeader
            showFilters={isHomePage}
            optionVehicles={optionVehicles}
          />
        </div>

        {/* Page Content */}
        <div className={`movyx-content${allowScroll ? ' allow-scroll' : ''}`}>
          <Outlet />
        </div>

      </div>
    </div>
  );
}
